import React from 'react';
import { X } from 'lucide-react';
import { scrollToTop } from '../utils/scroll';
import { motion } from 'framer-motion';
export function WhatWeAreNot() {
  const notItems = [{
    icon: <X size={28} className="text-red-500" data-id="element-127" />,
    title: 'Not a marketing agency',
    description: 'We don\'t charge $5K-$15K/month for SEO, PPC management, or "brand awareness." We deliver qualified cases on performance models.'
  }, {
    icon: <X size={28} className="text-red-500" data-id="element-128" />,
    title: 'Not a lead aggregator',
    description: "We don't sell the same lead to 5-10 attorneys like Avvo or Martindale. Our cases are exclusive."
  }, {
    icon: <X size={28} className="text-red-500" data-id="element-129" />,
    title: 'Not an in-house hire',
    description: "We don't cost $60K-$100K/year plus benefits and training. We operate as your outsourced intake team."
  }, {
    icon: <X size={28} className="text-red-500" data-id="element-130" />,
    title: 'Not a referral network',
    description: "We don't rely on inconsistent referrals. We generate fresh, inbound interest daily through targeted campaigns."
  }];
  return <section className="w-full px-6 md:px-12 py-24 bg-black" data-id="element-131">
      <div className="max-w-6xl mx-auto" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-16" data-id="element-133">
          <h2 className="font-display text-xl font-medium text-red-500 mb-3" data-id="element-134">
            OUR DIFFERENTIATION
          </h2>
          <h3 className="font-display text-3xl md:text-4xl font-bold" data-id="element-135">
            What Makes Us Different
          </h3>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-136">
          {notItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group p-6 md:p-8 rounded-xl border border-white/5 hover:bg-white/[0.02] transition-all" data-id="element-137">
              <div className="flex gap-5" data-id="element-138">
                <div className="mt-1 group-hover:scale-110 transition-transform" data-id="element-139">
                  <motion.div whileHover={{
                scale: 1.1
              }} className="relative" data-id="element-140">
                    {item.icon}
                    <div className="absolute inset-0 bg-red-500/20 blur-lg rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-141" />
                  </motion.div>
                </div>
                <div data-id="element-142">
                  <h4 className="font-bold text-lg mb-3" data-id="element-143">{item.title}</h4>
                  <p className="text-gray-300 leading-relaxed" data-id="element-144">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-16 text-center" data-id="element-145">
          <a href="https://calendly.com/customers-on-command/customers-on-command-1-1-interview" target="_blank" rel="noopener noreferrer" className="inline-block bg-primary hover:bg-primary-hover text-black font-medium text-sm py-4 px-10 rounded-full transition-all hover:-translate-y-0.5 active:translate-y-0 md:sticky md:bottom-8" data-id="element-146">
            APPLY NOW
          </a>
        </motion.div>
      </div>
    </section>;
}